import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';

export const getEventTypeDetail = async (eventType) => {
  const url = `${BASE_PATH_API}/${ROOT}/event/${eventType}`;
  const res = await axios({ url });
  return res.data.data;
};
